import type { Locale } from "@/lib/i18n";
import { priorityHtmlBlock } from "@/lib/resource-content-enhancements";

const LLANTAS_SLUGS = new Set([
  "llantas-cavazos-shopify-migration-case-study",
  "caso-llantas-cavazos-migracion-shopify",
  "llantas-cavazos-migracion-shopify",
]);

export function LlantasEvidenceModule({
  slug,
  locale,
}: {
  slug: string;
  locale: Locale;
}) {
  if (!LLANTAS_SLUGS.has(slug)) return null;
  const html = priorityHtmlBlock("llantas-cavazos-case-study", locale);
  if (!html) return null;

  return (
    <div className="mx-auto mt-16 max-w-4xl px-6">
      <div
        className="prose prose-lg prose-neutral max-w-none rounded-3xl border border-border bg-card/40 p-6 prose-headings:font-display prose-headings:tracking-tight prose-h2:text-3xl prose-h3:text-xl prose-p:leading-[1.75] prose-a:font-medium prose-a:text-foreground prose-a:underline-offset-4 prose-table:border prose-table:border-border prose-th:bg-card prose-th:p-3 prose-td:border-t prose-td:border-border prose-td:p-3 dark:prose-invert sm:p-10"
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </div>
  );
}
